import script from "./InnerTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./InnerTemplate.vue?vue&type=script&setup=true&lang=js"

import "./InnerTemplate.vue?vue&type=style&index=0&id=685f1872&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685f1872"]])

export default __exports__